// extracted by mini-css-extract-plugin
export default {"container":"image-modal_container__Qs-M6","controls":"image-modal_controls__FYiMy","image":"image-modal_image__tct+l"};